import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import A from '@dbh/link';
import Text from '@dbh/text';
import '@dbh/theme-values';
import { useMakeSelect } from '@dbh/reselect-extra';
import { makeSelectUrlTermsAndConditionsPage } from '@dbh/webpages-redux';

/*
 *
 * Constants: `@dbh/terms-and-conditions-link`.
 *
 */const TRANSLATION_IDS=Object.freeze({termsConditionsTranslationId:"components.BookingForm.credit_card.terms_conditions"});

const TermsAndConditionsLink=/*#__PURE__*/memo(a=>{let{size:b}=a;const c=useMakeSelect(makeSelectUrlTermsAndConditionsPage);return/*#__PURE__*/_jsx(A,{to:""+c,title:TRANSLATION_IDS.termsConditionsTranslationId,target:"_blank",intlFormatterTitle:!0,textUnderlineOnlyOnHover:!0},void 0,/*#__PURE__*/_jsx(Text,{color:"brandThird",size:b,intlFormatter:!0},void 0,TRANSLATION_IDS.termsConditionsTranslationId))});TermsAndConditionsLink.displayName="TermsAndConditionsLink";

export { TermsAndConditionsLink as default };
